const CMS_URL = (import.meta.env.VITE_CMS_URL as string | undefined)?.replace(/\/$/, "") ?? "http://localhost:3001";

export type NewsletterPost = {
  id: number;
  beehiivPostId: string;
  title: string;
  slug: string;
  publishedAt: string;   // ISO date string
  thumbnailUrl: string;
  excerpt: string;
  subject: string;
  authors: string;       // comma-separated
  tags: string;          // comma-separated
  externalUrl: string;
  body: string;          // raw HTML
  lastSyncedAt: string;
};

type CmsListResponse = {
  docs: NewsletterPost[];
  totalDocs: number;
};

export async function fetchNewsletterPosts(limit = 30): Promise<NewsletterPost[]> {
  const url = `${CMS_URL}/api/newsletter-posts?sort=-publishedAt&limit=${limit}&depth=0`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`CMS error ${res.status}`);
  const json = (await res.json()) as CmsListResponse;
  return json.docs ?? [];
}

export async function fetchNewsletterPostBySlug(slug: string): Promise<NewsletterPost | null> {
  const url = `${CMS_URL}/api/newsletter-posts?where[slug][equals]=${encodeURIComponent(slug)}&limit=1&depth=0`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`CMS error ${res.status}`);
  const json = (await res.json()) as CmsListResponse;
  return json.docs?.[0] ?? null;
}